<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Excel Log Report</h1>
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="start_date">Start Date</label>
                                            <input type="date" id="start_date" v-model="search.start_date" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="end_date">End Date</label>
                                            <input type="date" id="end_date" v-model="search.end_date" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>User</label>
                                            <v-select name="user_id"
                                                v-model="search.user_id"
                                                label="text"
                                                :reduce="item => item.id"
                                                :options="userList"
                                                :placeholder="$t('globalTrans.select')"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group d-flex align-items-center" style="margin-top:28px;">
                                            <button class="btn btn-info btn-sm mr-1" type="submit" @click.prevent="searchData">
                                                <i class="fa fa-search"></i> Filter
                                            </button>
                                            <button class="btn btn-warning btn-sm" type="button" :disabled="downloading" @click.prevent="excelDownload">
                                                <i class="fa fa-download"></i> Excel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <b-overlay :show="loading">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped table-sm">
                                            <thead>
                                                <tr class="text-center">
                                                    <th>SL</th>
                                                    <th>Date</th>
                                                    <th>Menu</th>
                                                    <th>Panel</th>
                                                    <th>File Type</th>
                                                    <th>Downloaded By</th>
                                                    <th>URL</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, key) in listData" :key="item.id" class="text-center">
                                                    <td>{{ pagination.slOffset + key }}</td>
                                                    <td>{{ item.created_at | dateTime }}</td>
                                                    <td>{{ item.menu_name }}</td>
                                                    <td class="text-capitalize">{{ item.panel }}</td>
                                                    <td class="text-uppercase">{{ item.file_type }}</td>
                                                    <td>{{ downloadedBy(item) }}</td>
                                                    <td class="text-left" style="word-break:break-all;">{{ item.url }}</td>
                                                </tr>
                                                <tr v-if="!listData.length && !loading">
                                                    <td colspan="7" class="text-center">No record found</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="mt-3">
                                        <b-pagination
                                            v-model="pagination.currentPage"
                                            :per-page="pagination.perPage"
                                            :total-rows="pagination.totalRows"
                                            @input="loadData"
                                        />
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
    </div>
</template>
<script>
    import config from '@/config'
    import moment from 'moment'

    export default {
        name: 'ExcelLogReport',
        data () {
            return {
                loading: false,
                downloading: false,
                listData: [],
                userList: [],
                search: {
                    start_date: moment().subtract(7, 'd').format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                    user_id: null
                },
                pagination: {
                    currentPage: 1,
                    totalRows: 0,
                    perPage: this.$store.state.commonObj.perPage,
                    slOffset: 1
                }
            }
        },
        filters: {
            dateTime (value) {
                return value ? moment(value).format('DD-MM-YYYY hh:mm A') : ''
            }
        },
        created () {
            this.loadUsers()
            this.loadData()
        },
        methods: {
            searchData () {
                this.pagination.currentPage = 1
                this.loadData()
            },
            downloadedBy (item) {
                if (item.user) {
                    return item.user.name
                }
                return item.merchant ? item.merchant.name : ''
            },
            getParams () {
                // the v-select clear button sets user_id to null; don't send it
                const params = Object.assign({}, this.search)
                if (!params.user_id) {
                    delete params.user_id
                }
                return params
            },
            async loadUsers () {
                const response = await config.getData('/report/excel-log-user-list')
                this.userList = response.success ? response.data : []
            },
            async loadData () {
                this.loading = true
                const params = Object.assign(this.getParams(), { page: this.pagination.currentPage, per_page: this.pagination.perPage })
                const response = await config.getData('/report/excel-log-report', params)
                this.loading = false
                if (response.success) {
                    this.listData = response.data.data
                    this.paginationData(response.data)
                } else {
                    this.listData = []
                }
            },
            paginationData (data) {
                this.pagination.currentPage = data.current_page
                this.pagination.totalRows = data.total
                this.pagination.perPage = data.per_page
                this.pagination.slOffset = data.per_page * data.current_page - data.per_page + 1
            },
            async excelDownload () {
                this.downloading = true
                try {
                    const response = await config.getFile('excel-download/excel-log', this.getParams())
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Excel-log-report.csv')
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(url)
                } catch (error) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',
                        color: '#dc3545'
                    })
                }
                this.downloading = false
            }
        }
    }
</script>
